
import AppLayout from "@/Layouts/AppLayout.vue";
import { PropType, defineComponent } from "vue";
import OutOfProductionNav from "@/Components/Reports/OutOfProductionNav.vue";
import Product from "@/types/Product";
import Pagination from "@/types/Pagination";
import ProductList from "@/Components/Product/ProductList.vue";
import Button from "@/Components/Buttons/Button.vue";
import { mdiPrinter } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import route from "ziggy-js";

export default defineComponent({
  layout: AppLayout,
  props: {
    products: {
      type: Object as PropType<Pagination<Product>>,
      required: false,
      default: () => [],
    },
    isAdmin: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
    },
  },
  setup(props) {
    return {
      mdiPrinter,
      route,
    };
  },
  components: { OutOfProductionNav, ProductList, Button, SvgIcon },
});
